<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('BookingOverview') }}
      <template #subtitle>
        {{ $t('BookingOverviewSub') }}
      </template>
      <template #action>
        <v-btn
          class="amber lighten-4 black--text mt-4"
          depressed
          @click="$emit('edit')"
        >
          <span
            class="text-truncate"
            style="max-width: 250px;"
          >
            {{ $t('BookingWebseiteConfig') }}
          </span>
        </v-btn>
      </template>
    </page-header>
    <v-row class="mt-4">
      <v-col cols="4">
        <dashboard-card
          :title="$t('TotalPeople')"
          :subtitle="$t('TotalPeopleHint')"
          :info="totalPersonCount + ' ' + $t('Pice')"
          color="yellow"
        />
      </v-col>
      <v-col cols="4">
        <dashboard-card
          :title="$t('RushHour')"
          :subtitle="$t('RushHourHint')"
          :info="highTime"
          color="pink"
        />
      </v-col>
      <v-col cols="4">
        <dashboard-card
          :info="$t('Online')"
          :title="$t('BookingWebseiteStatus')"
          :subtitle="$t('BookingWebseiteStatusHint')"
          color="green"
        >
          <template #action>
            <div>
              <v-img
                :src="QRCode"
                width="80"
              />
            </div>
          </template>
        </dashboard-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getReservationStatus, ifReserveOpen } from '@/model/dataLayer/service/reservation/reservation'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import DashboardCard from '@/views/AadenPages/dashboard/components/DashboardCard.vue'
import { getCurrentReservation } from '@/model/dataLayer/service/reservation/reservationStatistic'
import { sumBy } from 'lodash'
import { groupBy, maxBy } from 'lodash-es'
import dayjs from 'dayjs'

export default {
  name: 'ActiveDashboard',
  components: {
    DashboardCard,
    PageHeader
  },
  data: function () {
    return {
      QRCode: '',
      hostName: '',
      reservationInfo: null,
      reservations: []
    }
  },
  computed: {
    totalPersonCount () {
      return sumBy(this.reservations, 'personCount')
    },
    highTime () {
      const time = maxBy(Object.values(groupBy(this.reservations, 'fromDateTime')),
        'length')?.[0]?.fromDateTime
      return time ? dayjs(time).format('HH:mm') : '-'
    }
  },
  async mounted () {
    const reserveStatus = (await ifReserveOpen())
    if (reserveStatus) {
      this.reservationInfo = await getReservationStatus()
      this.hostName = 'https://' + this.reservationInfo.subDominName + '.reservation.aaden.io'
      this.QRCode = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + this.hostName
    }
    this.reservations = await getCurrentReservation()
  }
}
</script>

<style scoped>

</style>
